import { ensureRouteData } from '@/app/query-client'
import { watchlistCollectionQueryOptions } from '@/features/watchlist/api/queries'
import type { RouterContext } from '@/routes/layouts/root'

/**
 * The `/watchlist` loader.
 *
 * MAIN: the member's lists, awaited — the page is one of them, and a
 * first-load failure has nothing to show but the route's error page.
 *
 * No secondary reads. `?list=` only picks which of the already-loaded lists
 * is drawn, so it needs nothing from the network and is not read here; the
 * add modal's "Popular now" rides in on this same collection, and its search
 * only runs once a member types.
 *
 * Its own module, as `app.guard.ts` is, so a test can mount it under a root
 * of its own. It imports from `api/` modules only — route loaders are not
 * code-split, so anything imported here ships in the entry chunk.
 */
export async function loadWatchlist({
  context: { queryClient },
}: {
  context: RouterContext
}): Promise<void> {
  await ensureRouteData(queryClient, watchlistCollectionQueryOptions())
}
